import * as React from 'react';

function SvgForward(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 17.99" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M14.67 11.68v5.71L24 8.62 14.67.01v5.21C3 5.22 0 18.01 0 18.01c3.31-5.78 8.32-6.33 14.67-6.33z" />
    </svg>
  );
}

const MemoSvgForward = React.memo(SvgForward);
export default MemoSvgForward;
